<template>
  <v-dialog
    v-model="internalValue"
    max-width="1100px"
    scrollable
    transition="dialog-bottom-transition"
  >
    <v-card>

      <!-- HEADER -->
      <v-card-title class="history-header">
        <v-icon left color="white">mdi-history</v-icon>
          Historial de Pagos
        <v-spacer />
      </v-card-title>

      <v-divider />

      <!-- TABLE -->
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="payments"
          item-key="id"
          dense
          class="elevation-0"
        >

          <!-- FECHA con TOOLTIP -->
          <template v-slot:[`item.payDate`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  class="link-like"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ formatDateShortText(item.payDate) }}
                </span>
              </template>
              <span>
                Tasa {{ item.interestFixed ? 'fija' : 'variable' }}
                <strong>{{ formatRate(item.paymentDateRate) }}%</strong>
              </span>
            </v-tooltip>
          </template>

          <!-- MONTO -->
          <template v-slot:[`item.amount`]="{ item }">
            {{ formatCurrency(item.payment?.pago * -1) }}
          </template>

          <!-- DESGLOSE -->
          <template v-slot:[`item.amortization`]="{ item }">
            {{ formatCurrency(item.amortization) }}
          </template>

          <template v-slot:[`item.interest`]="{ item }">
            {{ formatCurrency(item.interest) }}
          </template>

          <template v-slot:[`item.ivaInterest`]="{ item }">
            {{ formatCurrency(item.ivaInterest) }}
          </template>

          <template v-slot:[`item.moratorium`]="{ item }">
            {{ formatCurrency(item.moratorium) }}
          </template>

          <template v-slot:[`item.advancePayment`]="{ item }">
            {{ formatCurrency(item.advancePayment) }}
          </template>

          <!-- FACTURA -->
          <template v-slot:[`item.factura`]="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!item.invoice?.facturamaId"
                >
                  <v-icon small color="primary">
                    mdi-download
                  </v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item @click="$emit('download-invoice', item, 'pdf')">
                  <v-list-item-icon>
                    <v-icon small color="primary">mdi-file-pdf-box</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>PDF</v-list-item-title>
                </v-list-item>

                <v-list-item @click="$emit('download-invoice', item, 'xml')">
                  <v-list-item-icon>
                    <v-icon small color="primary">mdi-xml</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>XML</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

        </v-data-table>
      </v-card-text>

      <v-divider />

      <!-- FOOTER -->
      <v-card-actions class="d-flex align-center px-4">
        <span
          v-if="!isRevolving"
          class="caption grey--text text--darken-1 font-italic"
        >
          * Todos los montos están expresados en {{ currency }}.
        </span>
        <span v-else />

        <v-spacer />

        <v-btn text color="primary" @click="close">
          Cerrar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import productMixin from '../../mixins/productMixin'

export default {
  name: 'PaymentsHistory',
  mixins: [productMixin],
  props: {
    value: { type: Boolean, default: false },
    payments: { type: Array, default: () => [] },
    currency: { type: String, default: '' },
    isRevolving: { type: Boolean, default: false }
  },

  computed: {
    internalValue: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },

    headers () {
      const headers = [
        { text: 'Fecha', value: 'payDate', align: 'center' },
        { text: 'Monto', value: 'amount', align: 'right' },
        { text: 'Amortización', value: 'amortization', align: 'right' },
        { text: 'I. Ordinario', value: 'interest', align: 'right' },
        { text: 'I.V.A.', value: 'ivaInterest', align: 'right' },
        { text: 'I. Moratorio', value: 'moratorium', align: 'right' },
        { text: 'Pago anticipado', value: 'advancePayment', align: 'right' },
        { text: 'Factura', value: 'factura', align: 'center', sortable: false }
      ]

      if (this.isRevolving) {
        headers.splice(0, 0, { text: 'Folio', value: 'folio', align: 'center' })

        const index = headers.findIndex(i => i.text === 'Monto')
        if (index !== -1) {
          headers.splice(index, 0, { text: 'Moneda', value: 'currency', align: 'center' })
        }
      }

      return headers
    }
  },

  methods: {
    close () {
      this.internalValue = false
    }
  }
}
</script>

<style scoped>
.link-like {
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
}

.history-header {
  background: #324A74;
  color: white !important;
  font-size: 1.2rem;
  font-weight: 700;
  padding: 16px 20px;
  letter-spacing: .4px;
  display: flex;
  align-items: center;
}
</style>
